/**
 *人事云-人力资源管理菜单
 */
export default [

  {
    label: 'organization',  // 组织安排
    // permission: 'hr_manage_menu',
    img: true,
    icon: 'icon-zuzhianpai',
    id:2,
    children: [
      {
        path: '/org/toOrgPage.action',
        label: 'organizationManagement',   // 组织管理
        permission: 'hr_org_manage',
        icon: 'icon-yonghu',
        id: 2-2,
      },
      {
        path: '/job/toJobPage.action',
        label: 'postManagement',  // 岗位管理
        permission: 'hr_post_manage',
        icon: 'icon-yonghu',
        id: 2-2,
      },
    ]
  },
  {
    label: 'personnelManagement', // 人事管理
    // permission: 'hr_manage_menu',
    img: true,
    icon: 'icon-renshiguanli',
    id:3,
    children: [
      {
        path: '/per/perEntryPage.action',
        label: 'onboardingManagement',  // 入职管理
        permission: 'hr_set_entry',
        icon: 'icon-yonghu',
        id:3-1
      },
      {
        path: '/per/toPerList.action?sysFunctionCode=OTA4NDAwMTY-',
        label: 'staffManagement', // 员工管理
        permission: 'hr_emp_manage',
        icon: 'icon-yonghu',
        id: 3-2,
      },
      {
        path: '/contract/toContractManage.action',
        label: 'contractManagement', // 合同管理
        permission: 'hr_contract_manage',
        icon: 'icon-yonghu',
        id: 3-3,
      }
    ]
  },
  {
    label: 'attendance',  // 考勤假期
    // permission: 'hr_manage_menu',
    img: true,
    icon: 'icon-kaoqinjiaqi',
    id:4,
    children: [
      {
        path: '/atndclockrecord/toindex.action',
        label: 'clockInRecords',  // 打卡记录
        permission: 'hr_clock_record',
        icon: 'icon-yonghu',
        id: 4-1,
      },
      {
        path: '/atndresult/toindex.action',
        label: 'attendanceResultProcessing', // 考勤结果处理
        permission: 'hr_atnd_result',
        icon: 'icon-yonghu',
        id: 4-2,

      },
      {
        path: '/atndmonthlyreport/toSummary.action',
        label: 'attendanceSummary',  // 考勤汇总
        permission: 'hr_atnd_sum',
        icon: 'icon-yonghu',
        id: 4-3,
      },
      {
        path: '/atndmonthlyreport/toindex.action',
        label: 'attendanceMonthlyReport',  // 考勤月报
        permission: 'hr_atnd_report',
        icon: 'icon-yonghu',
        id: 4-4,
      },
      {
        path: '/vacnstandard/queryindex.action',
        label: 'leaveQuery',  // 休假查询
        permission: 'hr_vanc_record',
        icon: 'icon-yonghu',
        id: 4-5,
      },
      {
        path: '/atnddaily/toDailyReport.action',
        label: 'attendanceDailyReport',  // 考勤日报
        permission: 'hr_atnd_day_report',
        icon: 'icon-yonghu',
        id: 4-6,

      },
      {
        path: '/atndset/toindex.action',
        label: 'attendanceSettings',  // 考勤设置
        permission: 'set_atnd',
        icon: 'icon-yonghu',
        id:4-7,
      },
      {
        path: '/vacnstandard/toindex.action',
        label: 'leaveSettings',  // 休假设置
        permission: 'set_vanc',
        icon: 'icon-yonghu',
        id:4-8
      },
    ]
  },
]
